import React from 'react';
import { Badge, Icon } from 'antd';
import { observer } from 'mobx-react';
import styled from 'styled-components';

interface ContentShoppingCartProp {
  onClick?: any;
}

const ContentDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  width: 50px;
  justify-content: center;
`;

export default observer((props: ContentShoppingCartProp) => {
  const { onClick } = props;
  if (nx.$root.isExternal) return null;
  return (
    <ContentDiv>
      <Badge count={nx.$root.cart.count}>
        <span style={{ fontSize: '25px' }}>
          <Icon type="shopping-cart" onClick={onClick} />
        </span>
      </Badge>
    </ContentDiv>
  );
});
